<!-- <mat-toolbar color="primary">
    <button [fxShow.lt-md]="true" [fxShow]="false"  mat-icon-button (click)="openSidenav()">
        <mat-icon>menu</mat-icon>
    </button>
    <span>Payment Configurations</span>
</mat-toolbar> -->
<div style="background: #f7f7f7;" class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px" [@routeAnimation]="true">
    <mat-tab-group #tabGroup mat-stretch-tabs>
        <mat-tab [disabled]="!hasRole('ADMIN')" label="Form">
            <mat-card *ngIf="tabGroup.selectedIndex===0">
                <div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
                    <payment-config-table-component *ngIf="tabGroup.selectedIndex === 0 " [data]='paymentConfigDetails' [tableType]="'form'">
                    </payment-config-table-component>
                </div>
            </mat-card>
        </mat-tab>

        <mat-tab [disabled]="!hasRole('ADMIN')" label="Payment Processor">
            <mat-card *ngIf="tabGroup.selectedIndex===1 ">
                <div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
                    <payment-config-table-component *ngIf="tabGroup.selectedIndex === 1 " [data]='paymentProcessorDetails' [tableType]="'paymentProcessor'">
                    </payment-config-table-component>
                </div>
            </mat-card>
        </mat-tab>

        <mat-tab [disabled]="!hasRole('ADMIN')" label="Payment Option">
            <mat-card *ngIf="tabGroup.selectedIndex===2 ">
                <div class="content" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
                    <payment-config-table-component *ngIf="tabGroup.selectedIndex === 2 " [data]='paymentOptionsDetails' [tableType]="'paymentOption'">
                    </payment-config-table-component>
                </div>
            </mat-card>
        </mat-tab>

        <mat-tab [disabled]="!hasRole('ADMIN')" label="Tax-Exempt Status Option ">
            <mat-card *ngIf="tabGroup.selectedIndex===3 ">
                <div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
                    <payment-config-table-component *ngIf="tabGroup.selectedIndex === 3 " [data]='taxExemptDetails' [tableType]="'taxExemptStatus'">
                    </payment-config-table-component>
                </div>
            </mat-card>
        </mat-tab>
    </mat-tab-group>
</div>